{
  "title": "Material Categories",
  "subtitle": "Classify categories as Raw Material, Semi-Finished Good, or Finished Good to drive BOM header/component eligibility.",
  "addCategory": "Add Category",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "name": "Name",
    "parentCategory": "Parent Category",
    "type": "Type",
    "status": "Status"
  },
  "form": {
    "name": "Category Name",
    "parentCategory": "Parent Category",
    "noParent": "None",
    "type": "BOM Type",
    "typeHint": "Drives which materials in this category can be used as a BOM header (FG/SFG) or component (RM/SFG).",
    "typeNone": "None",
    "typeRm": "Raw Material",
    "typeSfg": "Semi-Finished Good",
    "typeFg": "Finished Good",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "validation": {
      "nameRequired": "Category name is required."
    }
  },
  "discardChanges": "Discard Changes",
  "saveCategory": "Save Category",
  "deleteCategory": {
    "message": "This category will be permanently removed."
  }
}
